(function () {
  'use strict';
  angular.module('vcfinance.privcat')
    .component('privcatnewentry', {
      restrict: 'E',
      bindings: {
      },
      template: `
      <div class="privcatnewentry-component" data-hook="privcatnewentry-component">
        <h3>Neue Privatleistung anlegen</h3>
        <div class="btn btn-success"   style="margin-bottom: 12px"
        ng-click="vm.addPrivcatEntry()" ng-hide="vm.newprivcatentry">Neue Privatleistung anlegen</div>
        <div ng-show="vm.newprivcatentry">
          <privcatentryform privcatentry="vm.newprivcatentry" parentsave="vm.saveNewPrivcatEntry(privcat)" oncancel="vm.cancel()"></privcatentryform>
        </div>
        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> Privatleistung erfolgreich angelegt!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info-circle"></i> Das Anlegen einer neuen Privatleistung wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> Privatleistung konnte nicht angelegt werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      </div>
      <div class="spacer-bottom">&nbsp;</div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Privcat', 'Rlog',
        function ($log, Privcat, Rlog) {
          let vm = this;
          vm.addPrivcatEntry = addPrivcatEntry;
          vm.saveNewPrivcatEntry = saveNewPrivcatEntry;
          vm.cancel = cancel;
          
          function addPrivcatEntry() {
            vm.newprivcatentry = {
              type: 'entry',
              repeatable: false,
              tax: 0,
              svs: {}
            };
            delete vm.created;
            delete vm.canceled;
          }
          
          function saveNewPrivcatEntry(privcat) {
            delete vm.newprivcatentry;
            Privcat.$create(privcat).$then(function () {
              vm.created = true;
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new privcatentry failed: ', err);
              Rlog.error('vcutils.privcat', 'privcatnew', 'Creation of new privcatentry failed: ', {error: err, privacatentry: privcat});
            });
          }
          
          function cancel() {
            delete vm.newprivcatentry;
            vm.canceled = true;
          }
        }] // controller
    }); // component

// klammerfriedhof
}());